import {
  IconArrowRight,
  IconMap2,
  IconClipboardCheck,
  IconFlask,
  IconShoppingCart,
  type IconProps,
} from '@tabler/icons-react';
import type { ComponentType } from 'react';

const ICONS: Record<string, ComponentType<IconProps>> = {
  atlas: IconMap2,
  preflight: IconClipboardCheck,
  processlab: IconFlask,
  sourcing: IconShoppingCart,
};

export function productIcon(id: string): ComponentType<IconProps> {
  return ICONS[id] ?? IconArrowRight;
}
